import { createApp } from 'vue'
import { createStore } from 'vuex'
import router from '../router'
import { getToken } from '../common/auth'

//获取当前时间
const now = new Date()
const state = {
  // 输入的搜索值
  searchText: '',
  // 当前登录用户
  user: {
    name: 'chatGPT',
    img: 'static/images/me.png',
  },
  // 对话好友列表
  chatlist: [
    {
      id: 1,
      user: {
        name: 'chatGPT',
        img: 'static/images/chat.png',
      },
      messages: [
        {
          content: '有什么需求，让chatGPT来帮你完成吧！',
          date: now,
        },
      ],
      index: 1,
    },
  ],
  // 好友列表
  friendlist: [],
  // 得知当前选择的是哪个对话
  selectId: 1,
  // 得知当前选择的是哪个好友
  selectFriendId: 0,

  gptType: 1,

  sessionId: 'default',
}

const mutations = {
  // 从localStorage 中获取数据
  initData(state) {
    // let data = localStorage.getItem(state.sessionId+"_"+state.gptType);
    // if(state.gptType==1){
    //     data = localStorage.getItem(state.sessionId+"_"+state.gptType);
    // }else{
    //     data = localStorage.getItem(state.sessionId+"_"+state.gptType);
    // }
    // if (data) {
    //     state.chatlist = JSON.parse(data);
    // }else{
    //     state.chatlist =[
    //         {
    //             id: 1,
    //             user: {
    //                 name: 'chatGPT',
    //                 img: 'static/images/chat.png'
    //             },
    //             messages: [
    //                 {
    //                     content: '有什么需求，让chatGPT来帮你完成吧！',
    //                     date: now
    //                 }
    //             ],
    //             index: 1
    //         }
    //     ]
    // }
    let data = ''
    var token = getToken()
  },
  //设置token
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  setGPTType: (state, type) => {
    state.gptType = type
  },
  setSessionId: (state, id) => {
    state.sessionId = id
  },
  // 获取搜索值
  search(state, value) {
    state.searchText = value
  },
  // 得知用户当前选择的是哪个对话。便于匹配对应的对话框
  selectSession(state, value) {
    state.selectId = value
  },
  // 得知用户当前选择的是哪个好友。
  selectFriend(state, value) {
    state.selectFriendId = value
  },
  //删除消息
  deleteLastMessage(state) {
    let result = state.chatlist.find((session) => session.id === state.selectId)
    result.messages.splice(result.messages.length - 1, 1)
  },
  // 发送信息
  sendMessage(state, msg) {
    let result = state.chatlist.find((session) => session.id === state.selectId)
    if (msg.type == 1) {
      result.messages.push({
        content: msg.content,
        date: new Date(),
        self: true,
      })
    } else {
      if (msg.send == 1) {
        result.messages.push({
          content: msg.reply,
          date: new Date(),
          self: false,
          send: 1,
        })
      } else {
        result.messages.push({
          content: msg.reply,
          date: new Date(),
          self: false,
          send: 3,
        })
      }
    }

    //  if(result.user.name === '机器人'){
    //      setTimeout(() => {

    //      },500)
    //  }
  },

  // 选择好友后，点击发送信息。判断在聊天列表中是否有该好友，有的话跳到该好友对话。没有的话
  // 添加该好友的对话 并置顶
  send(state) {
    let result = state.friendlist.find((friend) => friend.id === state.selectFriendId)
    let msg = state.chatlist.find((msg) => msg.user.name === result.remark)
    if (!msg) {
      state.selectId = 1
      for (let i = 0; i < state.chatlist.length; i++) {
        state.chatlist[i].id++
        state.chatlist[i].index++
      }
      state.chatlist.unshift({
        id: 1,
        user: {
          name: result.remark,
          img: result.img,
        },
        messages: [
          {
            content: '已经置顶聊天，可以给我发信息啦！',
            date: new Date(),
          },
        ],
        index: 1,
      })
    } else {
      state.selectId = msg.index
      router.push({ path: '/chat' })
    }
  },
}
const getters = {
  // 筛选出含有搜索值的聊天列表
  searchedChatlist(state) {
    let sessions = state.chatlist.filter((sessions) =>
      sessions.user.name.includes(state.searchText),
    )
    return sessions
  },
  // 筛选出含有搜索值的好友列表
  searchedFriendlist(state) {
    let friends = state.friendlist.filter((friends) => friends.remark.includes(state.searchText))
    return friends
  },
  // 通过当前选择是哪个对话匹配相应的对话
  selectedChat(state) {
    let session = state.chatlist.find((session) => session.id === state.selectId)
    return session
  },
  // 通过当前选择是哪个好友匹配相应的好友
  selectedFriend(state) {
    let friend = state.friendlist.find((friend) => friend.id === state.selectFriendId)
    return friend
  },
  messages(state) {
    let session = state.chatlist.find((session) => session.id === state.selectId)
    return session.messages
  },
  getToken: (state) => state.token,
  getGPTType(state) {
    if (state.gptType) {
      return state.gptType
    }
  },
  getSessionId(state) {
    if (state.sessionId) {
      return state.sessionId
    }
  },
}

const actions = {
  search: ({ commit }, value) => {
    setTimeout(() => {
      commit('search', value)
    }, 100)
  },
  selectSession: ({ commit }, value) => commit('selectSession', value),
  selectFriend: ({ commit }, value) => commit('selectFriend', value),
  deleteLastMessage: ({ commit }) => commit('deleteLastMessage'),
  sendMessage: ({ commit }, msg) => commit('sendMessage', msg),
  send: ({ commit }) => commit('send'),
  initData: ({ commit }) => commit('initData'),
  setGPTType: ({ commit }, type) => commit('setGPTType', type),
  setSessionId: ({ commit }, id) => commit('setSessionId', id),
}
const store = createStore({
  state,
  mutations,
  getters,
  actions,
})

// 监听聊天列表的值， 发生变化就保存在localStorage中
store.watch(
  (state) => state.chatlist,
  (val) => {
    if (state.gptType == 1) {
      localStorage.setItem(state.sessionId + '_' + state.gptType, JSON.stringify(val))
    } else {
      localStorage.setItem(state.sessionId + '_' + state.gptType, JSON.stringify(val))
    }
  },
  {
    deep: true,
  },
)
export default store
